module.exports = __webpack_public_path__ + "img/mood_cry.8d9154bc.png";